export const formatStorageBytes = (bytes?: number | null) => {
  if (bytes === null || bytes === undefined) return '—';
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const unitIndex = Math.min(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1000)), units.length - 1);
  const value = bytes / 1000 ** unitIndex;
  return `${value.toFixed(unitIndex > 1 ? 1 : 0)} ${units[unitIndex]}`;
};

export const formatStorageDate = (value?: string | null) => {
  if (!value) return '—';
  return new Date(value).toLocaleString();
};

export const formatStorageLabel = (value: string) =>
  value
    .toLowerCase()
    .split('_')
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(' ');
